import { useState } from 'react';
import type { RowWarning } from '@integratio/core';
import { AlertTriangle, ChevronDown, ChevronUp, ShieldCheck } from 'lucide-react';

export function DataQualityWarnings({ warnings }: { warnings: RowWarning[] }): JSX.Element {
  const [open, setOpen] = useState(false);

  if (warnings.length === 0) {
    return (
      <section className="card flex items-center gap-3 p-5 text-sm text-state-positive">
        <ShieldCheck className="h-5 w-5" aria-hidden />
        Nenhuma inconsistência encontrada nos campos essenciais.
      </section>
    );
  }

  const visible = open ? warnings : warnings.slice(0, 5);

  return (
    <section className="card overflow-hidden">
      <button
        type="button"
        className="flex w-full items-center justify-between gap-4 p-5 text-left"
        onClick={() => setOpen((value) => !value)}
        aria-expanded={open}
      >
        <span className="flex items-center gap-3 text-sm font-semibold text-state-attention">
          <AlertTriangle className="h-5 w-5" aria-hidden />
          {warnings.length} {warnings.length === 1 ? 'possível inconsistência' : 'possíveis inconsistências'} nos dados
          importados
        </span>
        {open ? <ChevronUp className="h-4 w-4 text-brand-slate" aria-hidden /> : <ChevronDown className="h-4 w-4 text-brand-slate" aria-hidden />}
      </button>

      <ul className="divide-y divide-brand-line border-t border-brand-line text-sm">
        {visible.map((warning, index) => (
          <li key={`${warning.rowNumber}-${warning.field}-${index}`} className="flex flex-wrap gap-2 px-5 py-3">
            <span className="rounded-lg bg-brand-mist px-2 py-0.5 text-xs font-semibold text-brand-slate">
              linha {warning.rowNumber}
            </span>
            <span className="font-medium text-brand-ink">{warning.stakeholder || '(sem nome)'}</span>
            <span className="text-brand-slate">{warning.message}</span>
          </li>
        ))}
      </ul>

      {!open && warnings.length > visible.length && (
        <p className="border-t border-brand-line px-5 py-3 text-xs text-brand-slate">
          + {warnings.length - visible.length} alertas. Clique acima para ver todos.
        </p>
      )}

      <p className="border-t border-brand-line bg-brand-mist px-5 py-3 text-xs text-brand-slate">
        Alertas não impedem a geração dos gráficos: os registros são processados exatamente como estão na planilha.
      </p>
    </section>
  );
}
